export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILED = 'SIGN_IN_FAILED';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILED = 'SIGN_OUT_FAILED';
export const SET_USER_C = 'SET_USER_C';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_FAILED = 'CREATE_ACCOUNT_FAILED';

export const FORGET_PASSWORD_REQUEST = 'FORGET_PASSWORD_REQUEST';
export const FORGET_PASSWORD_REQUEST_SUCCESS = 'FORGET_PASSWORD_REQUEST_SUCCESS';
export const FORGET_PASSWORD_REQUEST_FAILED = 'FORGET_PASSWORD_REQUEST_FAILED';

export const VALIDATING_TOKEN = 'VALIDATING_TOKEN';
export const VALIDATING_TOKEN_SUCCESS = 'VALIDATING_TOKEN_SUCCESS';
export const VALIDATING_TOKEN_FAILED = 'VALIDATING_TOKEN_FAILED';

export const RESET_FORGOT_PASSWORD_TOKEN_REQUEST_SUCCESS = 'RESET_FORGOT_PASSWORD_TOKEN_REQUEST_SUCCESS';
export const RESET_ERROR_MSGS = 'RESET_ERROR_MSGS';
